import React, { Component, Fragment } from 'react';
import LightGallery from 'lightgallery/react';

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

import { image_url } from '../../config/Api';
import NoImage from '../../img/no_image.jpeg';

export default function ImageGallery(props) {
    const onInit = () => {
        console.log('lightGallery has been initialized');
    };
    return (
        <div className="image-preview">
            <LightGallery
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom]}
            >


                {props.content.map((row, key) => {
                    return (
                        <a href={`${image_url}${row.preview_image}`} className="gallery-grid">
                                <div className="gallery-single">
                                    <img alt={row.caption} src={`${image_url}${row.preview_image}`} />
                                    <p>{row.caption}</p>
                                </div>
                        </a>
                    )
                })}

            </LightGallery>
        </div>
    );
}



